import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'app/core/route.service';
import { extract } from 'app/core/i18n.service';
import { SearchProcessesComponent } from 'app/searchProcesses/searchProcesses.component';


const routes: Routes = Route.withShell([
  { path: 'process/search/:searchQuery', component:  SearchProcessesComponent, data: { title: extract('Search Processes') } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SearchProcessesRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/searchProcesses/searchProcesses-routing.module.ts